import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import styles from "./styles";
import Container from "@material-ui/core/Container";

import ViewRecord from "../ViewRecord";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../../../Component/CustomButton";

const useStyles = makeStyles(styles);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AuditViewDialog = ({ open, onClose, record }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(open);
  const { t } = useTranslation();

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = () => {
    setIsOpen(false);
    if (onClose !== undefined && typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="add-document-modal"
      open={isOpen}
      fullWidth={true}
      maxWidth="xl"
      disableBackdropClick
    >
      <DialogTitle id="add-document-modal" onClose={handleClose}>
        <Typography className={classes.panelTitle}>{t("labels.audit.viewRecords")}</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Container>
          <ViewRecord record={record} />
        </Container>
      </DialogContent>
      <DialogActions>
        <CustomButton variant="secondary" onClick={handleClose}>
          {t("labels.common.close")}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default AuditViewDialog;
